import React from 'react'
import { CSpinner } from '@coreui/react'
import PropTypes from 'prop-types'

export const Loader = ({ show = true, message = 'Loading, please wait...' }) => {
  if (!show) return null
  return (
    <div className="overlay-loading d-flex flex-column justify-content-center text-center col-6">
      <CSpinner
        color="dark"
        style={{ height: '120px', width: '120px' }}
        className="mx-auto fs-3 mb-3"
      />
      <div className="fs-3 text-dark">{message}</div>
    </div>
  )
}

Loader.propTypes = {
  message: PropTypes.string,
  show: PropTypes.bool,
}
